export const CULTURE_COOKIE_EXPIRY = '9999-12-30T22:00:00.000Z';
